module.exports = __webpack_public_path__ + "img/law2m.6901e587.webp";